"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AppSettingsProvider: ()=>_context.AppSettingsProvider,
    useAppSettings: ()=>_context.useAppSettings
});
const _context = require("./context");
